import React from 'react';
import Layout from './Layout';
import { useAuth } from '../utils/AuthContext';
import { FileActivityLogs } from '../components/FileActivity'; // Import your existing component
import { Box } from '@mui/material';

const AdminLogs = () => {
  const { user } = useAuth();

  return (
    <Layout>
      <Box sx={{ 
        p: 3, 
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
      }}>
        <FileActivityLogs />
      </Box>
    </Layout>
  );
};

export default AdminLogs;